const actionTypes = {
  SET_MODAL_DETAIL_FOLDER_ACTIVED: 'setModalDetailFolderActived',
  SET_MODAL_DETAIL_FOLDER_SUBMIT_ACTIVED: 'setModalDetailFolderSubmitActived',
  SET_MODAL_DETAIL_FOLDER_DELETE_ACTIVED: 'setModalDetailFolderDeleteActived',
  SET_MODAL_DETAIL_FOLDER_CANCEL_ACTIVED: 'setModalDetailFolderCancelActived',
  SET_MODAL_DETAIL_TREE_ACTIVED: 'setModalDetailTreeActived',
  SET_MODAL_DETAIL_OTHER_PRODUCT_DOCUMENT_ADD_ACTIVED:
    'setModalDetailOtherProductDocumentAddActived',
  SET_MODAL_DETAIL_OTHER_PRODUCT_DOCUMENT_SUBMIT_ACTIVED:
    'setModalDetailOtherProductDocumentSubmitActived',
  SET_MODAL_DELETE_PRODUCT_ACTIVED: 'setModalDeleteProductActived',
  SET_PRODUCT_SAVE_FOLDER_LIST: 'setProductSaveFolderList',
  SET_ORIGIN_FOLDER_LIST: 'setOrigenFolderList',
  SET_DISPLAY_FOLDER_LIST: 'setDisplayFolderList',
  SET_DISPLAY_FOLDER_LIST_BACKUP: 'setDisplayFolderListBackup',
  SET_CHANGED_FOLDER_LIST: 'setChangedFolderList',
  SET_CALL_API: 'setCallApi',
  SET_ERROR_MESSAGES_FOLDER_LIST: 'setErrorMessagesFolderList',
  SET_ERROR_MESSAGES_FOLDER_ADD: 'setErrorMessagesFolderAdd',
  SET_DELETE_FOLDER_ID: 'setDeleteFolderId',
  SET_POST_ADD_DOCUMENTS: 'setPostAddDocuments',
  SET_CALL_API_DOCUMENTS: 'setCallApiDocuments',
  SET_OTHER_PRODUCT_DOCUMENTS: 'setOtherProductDocuments',
  SET_CSV_UPLOAD_PAGE: 'setCsvUploadPage',
  SET_CSV_UPLOAD_PAGE_STATUS: 'setCsvUploadPageStatus',
  SET_CSV_UPLOAD_PAGE_NUMBER: 'setCsvUploadPageNumber',
  SET_CSV_UPLOAD_GOODS_NAME: 'setCsvUploadGoodsName',
  SET_CSV_UPLOAD_GOODS_LIST: 'setCsvUploadGoodsList',
  SET_CSV_UPLOAD_FILE_NAME: 'setCsvUploadfileName',
  SET_CSV_UPLOAD_FILE_LIST: 'setCsvUploadfileList',
  SET_SELECTED_FILE: 'setSelectedFile',
}

export default actionTypes
